/* globals process */

import client from './client';
import lscache from 'lscache';
import backupContent from '@/lang/content/global.content.lang';

export default {
  contentAreaMap: {},
  contentArray: [],
  backupContent: backupContent,
  gettingContent: false,
  getContentAreaMap() {
    return new Promise((resolve) => {
      lscache.flushExpired();
      let content = lscache.get(
        'contentAreas' + process.env.VUE_APP_CONTENTFUL_CACHE_PREFIX,
      );
      if (content) {
        this.contentAreaMap = content;
        resolve(this.contentAreaMap);
      } else {
        this.getEntries()
          .then(() => {
            lscache.set(
              'contentAreas' + process.env.VUE_APP_CONTENTFUL_CACHE_PREFIX,
              this.contentAreaMap,
              1440,
            );
            resolve(this.contentAreaMap);
          })
          .catch(() => {
            this.contentAreaMap = this.backupContent;
            resolve(this.contentAreaMap);
          });
      }
    });
  },
  getEntries() {
    return new Promise((resolve, reject) => {
      let self = this;

      getContent();

      function getContent() {
        client
          .getEntries({
            limit: 1000,
            skip: self.contentArray.length,
          })
          .then((entries) => {
            self.contentArray = self.contentArray.concat(
              client.parseEntries(entries).items,
            );
            if (entries.total <= self.contentArray.length) {
              self.contentArray.forEach((contentArea) => {
                if (contentArea.fields.contentAreaSlug) {
                  self.contentAreaMap[
                    contentArea.fields.contentAreaSlug
                  ] = contentArea;
                }
              });

              self.gettingContent = false;
              resolve();
            } else {
              getContent();
            }
          })
          .catch(reject);
      }
    });
  },
};
